<ng-content select="[slideToggleContainerPrefix]"></ng-content>
<ng-content select="[slideToggleContainerContent]"></ng-content>
<ng-content select="[slideToggleContainerSuffix]"></ng-content>
